
import { MagnitudesModel } from '@/store/catalogos/magnitudes';
import { UnidadModel } from '@/store/catalogos/unidad';
import { Util } from '@/utils/util';
import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CatalogoMagnitudesService } from '@services/catalogo/catalogoMagnitudes.service';
import { CatalogoUnidadService } from '@services/catalogo/catalogoUnidad.service';
import { ValidatorsService } from '@services/util/validators.service';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-formulario-unidad',
  templateUrl: './formulario-unidad.component.html',
  styleUrls: ['./formulario-unidad.component.scss']
})
export class FormularioUnidadComponent {
  form: FormGroup;
  mostrarBoton: boolean = true;
  title = "Nueva Unidad";

  variableControl = new FormControl<string>('', Validators.required); 
  variableList: MagnitudesModel[] = [];
  filteredVariable$: Observable<MagnitudesModel[]>; 

  constructor(
    private util: Util,
    private datePipe: DatePipe,
    private magnitudService: CatalogoMagnitudesService,
    private unidadService: CatalogoUnidadService,
    public dialogRef: MatDialogRef<FormularioUnidadComponent>,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    console.log(data);
    if (data.update) {
      this.title = "Modificar Unidad";
    }
    if (data.view) {
      this.title = "Vista unidad";
    }
  }

  ngOnInit(): void {
    this.buildForm(this.data?.row);
    this.variableLista();
    this.filteredVariable$ = this.variableControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

  async variableLista() {
    this.magnitudService.getAll().subscribe(data => {
      this.variableList = data;

      if (this.data?.row?.variable?.idVariable) {
        const variableSeleccionado = this.variableList.find(
          (col) => col.idVariable === this.data?.row?.variable?.idVariable
        );
        if (variableSeleccionado) {
          this.variableControl.setValue(
            `${variableSeleccionado.nombreVariable}`
          );

          this.form.get('idVariable')?.setValue(variableSeleccionado.idVariable);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de colaboradores.");
    });
  }

  private _filter(value: string): MagnitudesModel[] {
    if (!this.variableList) {
      return []; // Retorna una lista vacía si la lista no está definida
    }
    console.log('Lista de variables:', this.variableList);

    const filterValue = value.trim().toLowerCase();
    return this.variableList.filter(variable =>
      (`${variable.nombreVariable}`)
        .toLowerCase()
        .includes(filterValue) ||
      variable.idVariable.toString().includes(filterValue)
    );
  }
  seleccionarVariable(event: any) {
    const variableSeleccionado = event.option.value;
    if (variableSeleccionado) {
      this.variableControl.setValue(
        `${variableSeleccionado.nombreVariable}`
      );

      this.form.get('idVariable')?.setValue(variableSeleccionado.idVariable);
    }
  }


  private buildForm(data: UnidadModel): void {
    this.form = new FormGroup({
      idUnidad: new FormControl(data?.idUnidad ?? null),
      nombreUnidad: new FormControl(data?.nombreUnidad ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      idVariable: new FormControl(data?.variable?.idVariable ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });

    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
      this.variableControl.disable();
    }
  }

 
  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }


  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }

  abrirAutocomplete() {
    if (!this.variableControl.value) {
      this.variableControl.setValue(' '); 
      this.variableControl.setValue('');
    }
  }


  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const unidad: UnidadModel = this.formToModel();
console.log(unidad);
    const request = this.data.insert
      ? this.unidadService.create(unidad)
      : this.unidadService.update(unidad);


    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        this.dialogRef.close({ data: response });
      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }


  private formToModel(): UnidadModel {
    const formValues = this.form.getRawValue();

    return {
      idUnidad: formValues.idUnidad ?? '',
      nombreUnidad: formValues.nombreUnidad ?? '',
      variable: {
        idVariable: formValues.idVariable ?? ''
      }
    };
  }
}
